module.exports = __webpack_public_path__ + "statics/img/cate3-5@2x.3e472a20.png";